import { createSelector } from 'reselect';
import {
  getSummitDataDTM,
  getPdpCardShortName
} from 'page_modules/business-pdp/redux';
import { getPageAllowedLists } from 'src/universal/redux/page';

export const getShouldRender = createSelector(
  [getPageAllowedLists, getPdpCardShortName],
  (allowedLists, shortName) => {
    return (allowedLists?.showFeaturedBenefitsTiles ?? []).indexOf(shortName) > -1;
  }
);

export const getSummitBenefitImpression = createSelector(
  [getSummitDataDTM],
  dtmEventArr => {
    let headerImpression = {};
    headerImpression = dtmEventArr.find(event => event.tag === 'featured_benefits');
    return headerImpression;
  }
);
